<template>
    <MasterTemplate 
        title="ข้อมูลลูกค้า" 
        :headers="headers" 
        :setData="setData"
        itemKey="customerId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
        >
        <template v-slot:formInput="{rules}">
            <v-row>
                <v-col cols="4" >
                    <v-text-field label="รหัสลูกค้า" :disabled="isEdit" autofocus maxlength="20" v-model="editedItem.customerCode" :rules="[rules.required, chkCode]"></v-text-field>
                </v-col>
                <v-col cols="8" >
                    <v-text-field  label="ชื่อลูกค้า" maxlength="100" v-model="editedItem.customerName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4" >
                    <v-text-field  label="บ้านเลขที่" maxlength="20" v-model="editedItem.houseNo"></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  label="ตำบล" maxlength="100" v-model="editedItem.subdistrict"></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  label="อำเภอ" maxlength="100" v-model="editedItem.district"></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="6" >
                    <v-text-field  label="จังหวัด" maxlength="50" v-model="editedItem.province"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <v-text-field  label="รหัสไปรษณีย์" maxlength="5" v-model="editedItem.postcode"></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="6" >
                    <v-text-field  label="เบอรโทร" maxlength="20" v-mask="'##-###-####'" v-model="editedItem.tel" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" >
                    <v-text-field  label="เบอร์มือถือ" maxlength="20" v-mask="'##-###-####'" v-model="editedItem.mobile"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6" >
                    <v-text-field  label="email" maxlength="20" v-model="editedItem.email"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-autocomplete
                        v-model="editedItem.branchCode"
                        label="สาขา"
                        :items="branchs"
                        item-text="branchName"
                        item-value="branchCode"
                        :rules="[rules.required]"
                    >
                    </v-autocomplete>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
import MasterTemplate from '@/components/MasterTemplate'
import {listCustomer, isExistCustomerCode, insertCustomer, updateCustomer, deleteCustomer} from '@/api/master/customer-api.js'
import {listBranch} from '@/api/master/branch-api.js'
export default {
    name: 'Customer',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (!this.isEdit && this.isDup == true) return 'รหัสลูกค้าซ้ำ';
            return true;
        }
    },
    watch: {
        'editedItem.customerCode': function(newVal, oldVal) {
            if (!this.editedItem.customerId) {
                this.editedItem.customerId = '-1';
            }
            if (!this.editedItem.branchCode) return;
            this.checkExists(newVal);
        }
    },
    data: () => ({
        isEdit: false,
        isDup: false,
        headers: [
            {text: 'รหัสสาขา', value: 'branchCode'},
            {text: 'รหัสลูกค้า', value: 'customerCode'},
            {text: 'ชื่อลูกค้า', value: 'customerName'},
            {text: 'โทร', value: 'tel'},
            {text: 'มือถือ', value: 'mobile'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        editedItem: {
            customerId: '-1',
            branchCode: 'A001',
            customerCode: '',
            customerName: '',
            houseNo: '',
            subdistrict: '',
            district: '',
            province: '',
            postcode: '',
            tel: '',
            mobile: '',
            email: ''
        },
        branchs: []
    }),
    methods: {
        checkExists(newVal) {
            if (newVal && this.editedItem.customerId) {
                isExistCustomerCode(newVal, this.editedItem.branchCode, this.editedItem.customerId).then(response => {
                    this.isDup = response;
                }).catch(e => {
                    this.isDup = false;
                });
            }
        },
        listData() {
            return listCustomer();
        },
        deleteData(item) {
            return deleteCustomer(item.customerId);
        },
        insertData() {
            return insertCustomer(this.editedItem);
        },
        updateData() {
            return updateCustomer(this.editedItem);
        },
        getItemName(item) {
            return item.customerName;
        },
        setData(item, isEdit) {
            this.editedItem = item;
            this.isEdit = isEdit;
        }
    },
    mounted() {
        listBranch().then(rs => {
            this.branchs = rs;
        });
    }
}
</script>
